<template>
  <div :class="this.classes">
    <div>
      <slot name="main"></slot>
    </div>
    <template v-if="this.hasExtended">
      <br />
      <a v-on:click="extend = true" class="cursor-pointer hover:underline" :class="[ extend ? 'hidden' : 'block' ]">
        {{ this.showExtendedText }}
      </a>
      <div v-show="extend">
        <slot name="extended"></slot>
        <br />
        <a v-on:click="extend = false" class="cursor-pointer hover:underline">
          {{ this.showLessText }}
        </a>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "ReadMore",
  props: {
    classes: String,
    hasExtended: {
      type: Boolean,
      default: false,
      required: false
    },
    showExtendedText: {
      type: String,
      default: 'Read More',
      required: false
    },
    showLessText: {
      type: String,
      default: 'Read Less',
      required: false
    },
  },
  data() {
    return {
      extend: false
    }
  }
}
</script>

<style scoped>

</style>